import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import {
  PagerPosition,
  PagerType,
  SelectionEvent,
  SortSettings,
} from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import {
  CompositeFilterDescriptor,
  distinct,
  filterBy,
  groupBy,
  GroupDescriptor,
  orderBy,
  SortDescriptor,
} from '@progress/kendo-data-query';
import { userList } from 'src/app/interfaces/dashboard';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { commonService } from 'src/app/services/common.service';
import { AcdService } from 'src/app/services/dashboard.service';
import { ExportReviewService } from 'src/app/services/export-review.service';
import { CalService } from 'src/app/auth/cal.service';
import { MenuItems, menuItems } from './menu-items';
import { ContextMenuComponent } from '@progress/kendo-angular-menu';
import { ExportService } from 'src/app/services/export.service';
import sanitizeHtml from 'sanitize-html';
import { State, process } from '@progress/kendo-data-query';

@Component({
  selector: 'app-grid',
  styleUrl: './grid.component.scss',
  templateUrl: './grid.component.html',
})
export class GridComponent {
  public gridFilter: any;
  reqbody: string = 'MY';
  reqNumber: number = 0;
  lastReqParam: string = 'MY';
  public excelOptions: any = {
    fileName: 'Export.xlsx',
  };
  iconPack = EMDMICONS;
  facheck = this.iconPacks.FaCheck;
  closeIcon = this.iconPacks.Faclose;
  filterType: string = 'value'; // default filter type
  lastFilterType: string = ''; // last filter type
  actionClicked: string = ''; // default filter type
  public show = false;
  public anchorElement: any;
  public commentsHistory: any = [];
  public exportData: any[] = [];
  public selectedIds: Set<number> = new Set<number>();
  roleSpecialist: boolean = false;
  public userList: userList[] = [];
  public userFullList: userList[] = [];
  AssignUserId: number = 0;
  public selectedUser = '';
  public gridData: any;
  public crIds: any;
  commentHistoryId: number = 0;

  // Context menu properties
  public menuItems: MenuItems[] = menuItems;
  private rowIndex: any;
  public selectedField: string = '';
  private rowId: number = 0;
  private contextItem: any;
  public showCommandRow: boolean = false;
  private clickedCellElement: HTMLElement | null = null;
  private activeCellElement: HTMLElement | null = null;
  isHistoryDataAvailable: boolean = false;
  @ViewChild('gridmenu') public gridContextMenu!: ContextMenuComponent;

  @ViewChild('grid') grid!: any;
  @ViewChild('excelExport', { static: false })
  excelExport!: ExcelExportComponent;
  @HostListener('document:keydown.escape', ['$event1']) handleEscapeEvent(
    event: KeyboardEvent
  ) {
    this.closePopup();
  }
  @Input() set setGridData(historyGridData: any) {
    this.resetGridFilter();
    if (historyGridData.length > 0) {
      this.isHistoryDataAvailable = true;
      this.crIds = historyGridData.map((x: any) => x.changeRequestId);
      this.reqbody = 'ALL';
      this.reqNumber = 2;
      this.reqNumber = 2;
      this.lastReqParam = 'ALL';      
      //this.gridData = historyGridData;
      this.gridData = historyGridData.map((item: any) => ({
        ...item,
        createdDate: item.createdDate ? this.parseDate(item.createdDate) : null,
        closedDate: item.closedDate ? this.parseDate(item.closedDate) : null,
        dueDate: item.dueDate ? this.parseDate(item.dueDate) : null,
        submissionDate: item.submissionDate ? this.parseDate(item.submissionDate) : null,
        mocDueDate: item.mocDueDate ? this.parseDate(item.mocDueDate) : null
      }));
      this.wholeGridData = historyGridData;
    } else {
      this.isHistoryDataAvailable = false;
      this.resetGrid();     
    }
  }
  public wholeGridData: any;
  public filteredData: any;
  group: GroupDescriptor[] = [];

  public type: PagerType = 'numeric';
  public buttonCount = 3;
  public info = true;
  public previousNext = true;
  public position: PagerPosition = 'bottom';
  public pageSize = 500;
  skip = 0;
  filtrCondition = {};
  conditionalFilter = {};
  columnValueList: { [key: string]: any[] } = {};
  ogColumnValueList: { [key: string]: any[] } = {};
  constructor(
    private acdservice: AcdService,
    private router: Router,
    private commonservice: commonService,
    private iconPacks: EmdmIcons,
    private exportReviewService: ExportReviewService,
    private calService: CalService,
    private exportService: ExportService
  ) {
    this.roleSpecialist =
      commonservice.isUserSpecialist() || commonservice.isUserAdmin();
    document.documentElement.style.setProperty('--display-hide-flex', 'none');
  }

  public sort: SortDescriptor[] = [{ field: 'changeRequestId', dir: 'desc' }];
  public payloadsort: SortDescriptor[] = [{ field: 'changeRequestId', dir: 'desc' }];
  public sortSettings: SortSettings = {
    mode: 'single',
    initialDirection: 'asc',
    allowUnsort: true,
  };


  public state: State = {
    skip: 0,
    take: 500,
    sort: [],
    filter: undefined,
    group: []
  };


  ngOnInit() {
    this.commonservice.isSpecialist.subscribe((x: boolean) => {
      this.roleSpecialist = x;
    });
    this.commonservice.isAdmin.subscribe((x: boolean) => {
      this.roleSpecialist = x || this.roleSpecialist;
    });
    if (!this.isHistoryDataAvailable) {
      this.getGridDataNew();
    }     
    this.getUserList();
    // console.log(this.calService.getUserInfo());
  }
  public onCellClick(e: any): void {
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();

      this.grid.closeRow(this.rowIndex);

      this.rowIndex = e.rowIndex;
      this.rowId = e.dataItem.Id;
      this.contextItem = e.dataItem;
      this.showCommandRow = false;
      this.selectedField = e.column.field;

      // Highlight the right-clicked cell with active state
      this.highlightActiveCell(e);

      this.gridContextMenu.show({
        left: originalEvent.pageX,
        top: originalEvent.pageY,
      });
    } else if (e.type === 'click') {
      // Handle regular cell click for highlighting
      this.highlightClickedCell(e);

      // Store clicked cell info for context menu
      this.rowIndex = e.rowIndex;
      this.rowId = e.dataItem.changeRequestId;
      this.contextItem = e.dataItem;
      this.selectedField = e.column.field;
    }
  }

  private highlightClickedCell(e: any): void {
    this.clearCellHighlighting();
    this.clearActiveCellHighlighting();
    // Get the clicked cell element
    const cellElement = e.originalEvent.target.closest('td');
    if (cellElement) {
      cellElement.classList.add('cell-clicked');
      this.clickedCellElement = cellElement;
    }
  }

  private highlightActiveCell(e: any): void {
    // Remove previous active cell highlighting
    this.clearCellHighlighting();
    this.clearActiveCellHighlighting();

    // Get the right-clicked cell element
    const cellElement = e.originalEvent.target.closest('td');
    if (cellElement) {
      // Add active highlighting to the right-clicked cell
      cellElement.classList.add('cell-active');
      this.activeCellElement = cellElement;
    }
  }

  public onContextMenuClose(): void {
    // Clear active cell highlighting when context menu closes
    this.clearActiveCellHighlighting();
    this.clearCellHighlighting;
  }

  public onSelect({ item }: any): void {
    const menuItem = item.text;

    // Clear active cell highlighting when menu item is selected
    this.clearActiveCellHighlighting();
    this.clearCellHighlighting();

    // Check if the context item not selected and the menu item is "Copy" or "Copy with Headers"
    if (!this.selectedIds.has(this.contextItem.changeRequestId)) {
      if (menuItem === 'Copy') {
        this.copygrid(
          [{ ...this.contextItem }],
          [{ field: this.selectedField }]
        );
      }
      if (menuItem === 'Copy with Headers') {
        this.copyWithHeaders(
          [{ ...this.contextItem }],
          [{ field: this.selectedField }]
        );
      }
      if (menuItem === 'CSV Export') {
        this.getGridDataNew_Export(menuItem);
      }
      if (menuItem === 'Excel Export (w/o styles)') {
        this.getGridDataNew_Export(menuItem);
      }
      return;
    }

    // Determine which data to use: filtered by selectedIds or wholeGridData
    let dataToExport: any[] = [];
    let dataToExportIndex: any[] = [];

    const stateNoPaging = { sort: this.sort, filter: this.gridFilter, group: this.group };
    const processed = process(this.gridData, stateNoPaging);

    const allRows = processed.data as any[];

    if (this.selectedIds && this.selectedIds.size > 0) {
      dataToExport = allRows.filter((row: any) =>
        this.selectedIds.has(row.changeRequestId)
      );
      // dataToExportIndex = (this.gridData?.data || [])
      //   .map((row: any, idx: number) => this.selectedIds.has(row.id) ? idx : -1)
      //   .filter((idx: number) => idx !== -1);
    } else {
      // dataToExport = this.wholeGridData || [];
      // this.getGridDataNew_Export(menuItem);
      return; // Exit early if no selection
    }

    switch (menuItem) {
      case 'Copy':
        this.copygrid(dataToExport);
        break;
      case 'Copy with Headers':
        this.copyWithHeaders(dataToExport);
        break;
      case 'CSV Export':
        this.csvExport(dataToExport);
        break;
      case 'Excel Export (w/o styles)':
        this.getGridDataNew_Export(
          menuItem,
          this.selectedIds ? Array.from(this.selectedIds) : []
        );
        break;
      default:
        break;
    }
  }

  // Helper to strip HTML tags and clean up value for clipboard/copy
  private cleanValue(value: any): string {
    if (value === undefined || value === null) return '';
    let str =
      value instanceof Date ? value.toLocaleDateString() : String(value);
    // Remove HTML tags
    str = sanitizeHtml(str, {
      allowedTags: [],
      allowedAttributes: {}
    });
    // Replace line breaks and tabs with space
    str = str.replace(/[\r\n\t]+/g, ' ');
    // Trim whitespace
    str = str.trim();
    // Escape double quotes by doubling them
    str = str.replace(/"/g, '""');
    // If value contains tab, quote, or newline, wrap in quotes
    if (/["\t\r\n]/.test(str)) {
      str = `"${str}"`;
    }
    return str;
  }

  // Generalized copy function for grid data, with optional headers and columns
  private copyGridData(
    data: any[],
    withHeaders: boolean = false,
    columns?: any[]
  ): void {
    if (!data || data.length === 0) {
      return;
    }
    // Use provided columns or get from grid
    const cols =
      columns ||
      this.grid?.columns
        ?.toArray?.()
        .filter((col: any) => !col.hidden && col.field) ||
      [];
    const headers = cols.map((col: any) => col.title || col.field);
    const fields = cols.map((col: any) => col.field);

    const rows = data.map((row) =>
      fields
        .map((field: string) => {
          const value = row[field];
          return !value ? '' : this.cleanValue(value);
        })
        .join('\t')
    );

    const text = withHeaders
      ? [headers.join('\t'), ...rows].join('\n')
      : rows.join('\n');

    navigator.clipboard.writeText(text).then(
      () =>
        console.log(
          `Copied grid data${withHeaders ? ' with headers' : ''} to clipboard`
        ),
      (err) =>
        console.error(
          `Failed to copy grid data${withHeaders ? ' with headers' : ''}`,
          err
        )
    );
  }

  // Copy grid data to clipboard (without headers)
  copygrid(data: any[], columns?: any[]) {
    this.copyGridData(data, false, columns);
  }

  // Copy grid data to clipboard (with headers)
  copyWithHeaders(data: any[], columns?: any[]) {
    this.copyGridData(data, true, columns);
  }

  csvExport(data: any[]) {
    if (!data || data.length === 0) {
      return;
    }
    // Get the visible columns in the same order as displayed in the grid
    const columns =
      this.grid?.columns
        ?.toArray?.()
        .filter((col: any) => !col.hidden && col.field) || [];
    const headers = columns.map(
      (col: any) => `"${(col.title || col.field).replace(/"/g, '""')}"`
    );
    const fields = columns.map((col: any) => col.field);

    // Prepare rows with values in the same order as fields
    const rows = data.map((row) => {
      return fields
        .map((field: string) => {
          let value = row[field];
          // Format dates as locale string
          if (value instanceof Date) {
            value = value.toLocaleDateString();
          }
          // Convert undefined/null to empty string
          if (value === undefined || value === null) {
            value = '';
          }
          if (value === false) {
            value = '';
          }
          // Escape double quotes and wrap in quotes
          return `"${String(value).replace(/"/g, '""')}"`;
        })
        .join(',');
    });

    const csvContent = [headers.join(','), ...rows].join('\r\n');
    // Create a Blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', 'FlexGrid.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  excelExportWithoutStyles(data: any[], showRows: number[] = []) {
    if (!data || data.length === 0) {
      return;
    }

    let showIndex: number[] = [];
    if (showRows && showRows.length) {
      let idHash = new Set(showRows);
      showIndex = (data || [])
        .map((row: any, idx: number) => (idHash.has(row.changeRequestId) ? idx : -1))
        .filter((idx: number) => idx !== -1);
    }

    // Get the visible columns in the same order as displayed in the grid
    const columns =
      this.grid?.columns
        ?.toArray?.()
        .filter((col: any) => !col.hidden && col.field) || [];
    const ExportColoumns = columns.map((col: any) => col.title || col.field);
    const fields = columns.map((col: any) => col.field);

    // Prepare rows with values in the same order as fields
    const rows = data.map((row) => {
      return fields.map((field: string) => {
        let value = row[field];
        // Format dates as locale string
        if (value instanceof Date) {
          value = value.toLocaleDateString();
        }
        // Convert undefined/null to empty string
        if (value === undefined || value === null) {
          value = '';
        }
        if (value === false) {
          value = '';
        }
        return value;
      });
    });

    this.exportService.exportExcel(rows, [ExportColoumns], 'Export', showIndex);

    return;
  }

  getGridDataNew_Export(type: string, selectedIds: any[] = []) {    
    this.acdservice
      .getGridDataNew(this.reqNumber)
      .subscribe((response: any) => {
        if (response) {
          let data = response;
          const stateNoPaging = { sort: this.sort, filter: this.gridFilter, group: this.group };
          const processed = process(this.gridData, stateNoPaging);

          const allRows = processed.data as any[];
          if (this.selectedIds && this.selectedIds.size > 0) {
            data = allRows.filter((row: any) =>
              this.selectedIds.has(row.changeRequestId)
            );

            if (type === 'CSV Export') {
              this.csvExport(data);
            } else if (type === 'Excel Export (w/o styles)') {
              this.excelExportWithoutStyles(data, selectedIds);
            }
          }
        }
      });
  }
  @ViewChild(TooltipDirective) public tooltipDir!: TooltipDirective;

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (
      (element.nodeName === 'TD' || element.className === 'k-column-title') &&
      element.innerText != '' &&
      element.innerText.length >= 20
    ) {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }  

  getGridDataNew() {
    this.acdservice.getGridDataNew(this.reqNumber).subscribe((response: any) => {
      if (response) {
          this.gridData = response.map((item: any) => ({
            ...item,
            createdDate: item.createdDate ? this.parseDate(item.createdDate) : null,
            closedDate: item.closedDate ? this.parseDate(item.closedDate) : null,
            dueDate: item.dueDate ? this.parseDate(item.dueDate) : null,
            submissionDate: item.submissionDate ? this.parseDate(item.submissionDate) : null,
            mocDueDate: item.mocDueDate ? this.parseDate(item.mocDueDate) : null
          }));
        this.wholeGridData = response;
      }

    });
  }

  public onDataStateChange(state: State): void {
    this.sort = state.sort || [];
    this.gridFilter = state.filter || { logic: 'and', filters: [] };
    this.group = state.group || [];
    this.state = state;
    this.filteredData = process(this.wholeGridData, this.state);
  }


  parseDate(dateString: string): Date {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }


  getUserList() {
    this.acdservice.getUsers().subscribe({
      next: (response: any) => {
        let data = response as any;
        this.userFullList = data;
        this.userList = data;
        this.userList.push({ id: -1, name: '(Blank)', email: '' });
      },
      error: (error: any) => {},
    });
  }

  public userFilterChange(filter: string): void {
    const lowerFilter = filter.toLowerCase();

    // Filter the list excluding the (Blank) item
    const filtered = this.userFullList.filter(
      (user) => user.name?.toLowerCase().includes(lowerFilter) && user.id !== -1
    );

    // Add (Blank) only if it's not already in the filtered list
    this.userList = [...filtered];

    const blankExists = this.userList.some(user => user.id === -1);
    if (!blankExists) {
      this.userList.push({ id: -1, name: '(Blank)', email: '' });
    }
  }

  groupChange(event: any) {
    this.group = event;
    this.gridData = groupBy(this.wholeGridData, this.group);
  }

  //click events
  public onClickMyRequests(): void {
    this.crIds = [];
    this.reqbody = 'MY';
    this.reqNumber = 0;
    this.lastReqParam = 'MY';
    this.resetGrid();
    this.resetGridFilter();
    this.getGridDataNew();
  }

  public onClickNewRequests(): void {
    this.crIds = [];
    this.reqbody = 'NEW';
    this.reqNumber = 1;
    this.lastReqParam = 'NEW';
    this.resetGrid();
    this.resetGridFilter();
    this.getGridDataNew();
  }

  public onClickAllRequests(): void {
    this.crIds = [];
    this.reqbody = 'ALL';
    this.reqNumber = 2;
    this.lastReqParam = 'ALL';
    this.lastFilterType = '';
    this.resetGrid();
    this.resetGridFilter();
    this.getGridDataNew();
  }

  resetGrid() {   
    this.group = [];
    this.gridData = [];
    this.wholeGridData = [];
    this.selectedIds.clear();
    this.conditionalFilter = {};
    this.skip = 0;
    this.pageSize = 500;    
    this.columnValueList = {};
    this.lastFilterType = '';
    // Clear cell highlighting when grid is reset
    this.clearCellHighlighting();
    this.clearActiveCellHighlighting();
  }

  onClickClearAll() {
    this.resetGridFilter();
  }

  resetGridFilter() {
    this.selectedIds.clear();
    const currentFilter = this.grid?.filter;
    if (currentFilter && currentFilter.filters && currentFilter.filters.length > 0) {
      this.grid.filter.filters = [];    
    }
    this.gridFilter = { logic: 'and', filters: [] };
    this.sort = [];
    this.group = [];
  }

  public onPageChange(event: any): void {
    this.skip = event.skip;
    this.pageSize = event.take;
  }

  public OnCRClick(event: Event) {
    event.preventDefault();
    const mouseEvent = event as MouseEvent;
    const target = event.target as HTMLElement;
    const value = target.getAttribute('data-value');

    // Check if Ctrl key (Windows/Linux) or Command key (Mac) is pressed
    if (mouseEvent.ctrlKey || mouseEvent.metaKey || mouseEvent.button === 1) {
      // Let the default behavior happen (open in new tab)
      // We don't call preventDefault() here
      // this.router.serializeUrl(this.router.createUrlTree([`ACD/ViewRequest?CR=${value}`]));
      const url = `#/ACD/ViewRequest?CR=${value}`;

      window.open(url, '_blank');
    } else {
      // For normal clicks, navigate in the same tab
      this.router.navigateByUrl(`ACD/ViewRequest?CR=${value}`);
    }
  }

  getHref(dataitem: any): string {
    return `#/ACD/ViewRequest?CR=${dataitem.changeRequestId}`;
  }

  public onClickExport(event: Event): void {
    if (this.selectedIds.size == 0) {
      this.commonservice.showNotificationMessage(
        'Select atleast one row.',
        'error',
        'center'
      );
      event.preventDefault();
    } else {
      const sortedIds = Array.from(this.selectedIds).sort((a, b) => b - a);
      this.exportReviewService
        .getExportReviewByCrId(sortedIds)
        .subscribe({
          next: (response: any) => {
            if (response.status === 200) {
              let timestamp = new Date();
              let fileName =
                this.commonservice.formatDateToReviewFormat(timestamp);
              //let fileOfBlob = new Blob(, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              this.commonservice.downloadFile(response.body, fileName);

              this.commonservice.showNotificationMessage(
                'file downloaded successfully',
                'success',
                'center'
              );
            } else if (response.status === 204) {
              this.commonservice.showNotificationMessage(
                'No data to export for review.',
                'info',
                'center'
              );
            }           
            else if (response.status === 500) {
              this.commonservice.showNotificationMessage(
                'Something went wrong while preparing the export. Please try again later or contact support.',
                'error',
                'center'
              );
            }
          },

          error: (error: any) => {
            const msg = (error?.message || '').toLowerCase();

            if (
              error?.status === 504 ||            // Gateway Timeout
              msg.includes('timeout') ||          
              msg.includes('timed out') ||
              msg.includes('time out')
            ) {
              this.commonservice.showNotificationMessage(
                'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
                'info',
                'center'
              );
            } else if (error?.status === 500) {
              this.commonservice.showNotificationMessage(
                'Something went wrong while preparing the export. Please try again later or contact support.',
                'error',
                'center'
              );           
            } else {
              // Generic error fallback
              this.commonservice.showNotificationMessage(
                'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
                'info',
                'center'
              );
            }
          },
        });
    }
  }

  generateLoadFiles() {
    if (this.selectedIds.size == 0) {
      this.commonservice.showNotificationMessage(
        'Select atleast one row.',
        'error',
        'center'
      );
    } else {
      this.acdservice.generateLoadFiles(Array.from(this.selectedIds)).subscribe(
        (response: any) => {
          if (response) {
            if (!response.body) {
              this.commonservice.showNotificationMessage(
                'No changes were found in the supplied change request. Please review the request build step.',
                'error',
                'center'
              );
            } else if (response.status === 200){
              const fileName = response.body.fileName;
              const fileData = atob(response.body.fileData); // Decode base64 string

              // Create a Blob from the file data
              const byteCharacters = fileData;
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/zip' });

              // Create a link element and trigger a download
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              this.commonservice.showNotificationMessage(
                'Generate Load Files Successfully',
                'success',
                'center'
              );
            }
            else if (response.status === 204) {
              this.commonservice.showNotificationMessage(
                'No changes were found in the supplied change request. Please review the request build step.',
                'error',
                'center'
              );
            }
            else if (response.status === 500) {
              this.commonservice.showNotificationMessage(
                'Something went wrong while generating load files. Please try again later or contact support.',
                'error',
                'center'
              );
            }
          }
        },
       (error: any) => {
          const msg = (error?.message || '').toLowerCase();

          if (
            error?.status === 504 ||     
            msg.includes('timeout') ||     
            msg.includes('timed out') ||
            msg.includes('time out')
          ) {
            this.commonservice.showNotificationMessage(
              'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
              'info',
              'center'
            );
          } else if (error?.status === 500) {
            this.commonservice.showNotificationMessage(
              'Something went wrong while generating load files. Please try again later or contact support.',
              'error',
              'center'
            );
          } else {
            // Generic error fallback
            this.commonservice.showNotificationMessage(
              'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
              'info',
              'center'
            );
          }
        }
      );
    }
  }

  public onExcelDownload() {
    this.commonservice.showNotificationMessage(
      'file downloaded successfully',
      'success',
      'center'
    );
  }

  //checking of grid row
  public OnSelectionChangeEvent(event: SelectionEvent): void {
    // Clear cell highlighting when row selection changes
    this.clearCellHighlighting();
    this.clearActiveCellHighlighting();

    event.selectedRows?.forEach(row => this.selectedIds.add(row.dataItem.changeRequestId));
    event.deselectedRows?.forEach(row => this.selectedIds.delete(row.dataItem.changeRequestId));

    this.selectedIds = this.commonservice.onGridSelection(
      this.selectedIds,
      event,
      'changeRequestId'
    );
  }

  get selectedKeys(): number[] {
    return Array.from(this.selectedIds);
  }

  private clearCellHighlighting(): void {
    if (this.clickedCellElement) {
      this.clickedCellElement.classList.remove('cell-clicked');
      this.clickedCellElement = null;
    }
  }

  private clearActiveCellHighlighting(): void {
    if (this.activeCellElement) {
      this.activeCellElement.classList.remove('cell-active');
      this.activeCellElement = null;
    }
  }

  //build openup
  public openPopup(anchor: HTMLElement, id: any): void {
    this.commentHistoryId = id;
    this.acdservice.getCommentsHistory(id).subscribe((data) => {
      this.commentsHistory = data;
      this.commentsHistory = this.commentsHistory.filter(
        (item: any) => item.status !== null
      );
      this.show = true;
    });
    this.anchorElement = anchor;    
  }

  public closePopup(): void {
    this.show = false;
    this.commentsHistory = null;
  }

  defaultFilter = {
    filters: [],
    logic: 'or',
  };

  setFilterType(field: string, value: string): void {
    this.filterType = field;
  }
  lastfilteredValue(value: string): void {
    this.lastFilterType = value;
  }
  setActionType(field: string): void {
    this.actionClicked = field;
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    let dataResult = distinct(this.wholeGridData, fieldName).map(
      (item: any) => item[fieldName]
    );

    return dataResult;
  }

  assignButton() {
    const crids = Array.from(this.selectedIds);
    const reqdata = {
      userId: this.AssignUserId as unknown as string,
      crIds: crids,
    };
    this.acdservice.assignCrToUser(reqdata).subscribe((data) => {
      this.acdservice.getGridDataNew(this.reqNumber).subscribe((response: any) => {
        if (response) {
          this.resetGrid();
          setTimeout(() => {
            this.getGridDataNew();
          }, 0);
          let message =
            reqdata.crIds.length + ' CR(s) Assigned to ' + this.selectedUser;
          this.commonservice.showNotificationMessage(message, 'success', 'center');
          this.AssignUserId = 0;
          this.selectedUser = '';
          this.selectedIds.clear();
        }
      });
    });
  }

  selectionChange(event: SelectionEvent) {
    if (event.selectedRows && event.selectedRows.length > 0) {
      event.selectedRows.forEach((row: any) => {
        this.selectedIds.add(row.dataItem.id);
      });
    }

    if (event.deselectedRows && event.deselectedRows.length > 0) {
      event.deselectedRows.forEach((row: any) => {
        this.selectedIds.delete(row.dataItem.id);
      });
    }
  }
  onUserValueChange(value: string) {
    this.selectedUser = value;
    if (this.selectedUser != '') {
      this.userList.map((data: any) => {
        if (data.name === this.selectedUser) {
          this.AssignUserId = parseInt(data.id);
        }
      });
    } else {
      this.AssignUserId = 0;
    }
  }

  onDoubleClick(autoComplete: AutoCompleteComponent) {
    autoComplete.toggle(true);
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
